<template>
    <div class="list px-4 py-5">
        <div class="b-name fs-4 mb-2 bold">{{this.offer.Merchant.Name}}</div>
        <div class="b-adderess fs-5 mb-2">{{this.offer && this.offer.Merchant && this.offer.Merchant.Addresses ? this.offer.Merchant.Addresses.Address.street : ''}}</div>
        <p class="fs-2">{{this.offer.Headline}}</p>

            <div class="mt-4">
                <a v-if="this.offer.ActiveSc == 'AVAILABLE' && !this.activatedNow" @click="showEnrollCardOrActivate" :disabled="activating" :class="(activating) ? 'button pink midsize mid me-3 isDisabled' : 'button pink midsize mid me-3'" >{{this.activating ? 'Activating' : 'Activate'}}</a>
                <a v-if="this.offer.ActiveSc != 'AVAILABLE' || this.activatedNow" href="javascript:"  class="button activated pink midsize mid me-3">Activated</a>
                <a href="javascript:;" @click.prevent="showOfferDetailModal" class="button pink-border tinysize mid">View details</a>
            </div>
        <p class="offerActivationFailedMsg" v-if="show_offer_activation_failed_msg">Offer Activation Failed</p>
        <span class="map-marker" style="background-color:#f03939">{{this.offerNumber || ''}}</span>
        <offer-calendar-details-component
            v-if="showDetailModal && this.offer && this.offer.OfferProvider == 'rewards_network'"
            @reload="reload"
            @showEnrollCardOrActivate="showEnrollCardOrActivate"
            :activatedNow="this.activatedNow"
            :offer="this.offer"
            :show_offer_activation_failed_msg="show_offer_activation_failed_msg"
        >
        </offer-calendar-details-component>
        <enroll-cards-component v-if="showEnrollModal"  :modalId="this.offer.OfferId"  @reload = "reload" :offer="this.offer"></enroll-cards-component>
    </div>
</template>

<script>
    import OfferCalendarDetailsComponent from './modals/OfferCalendarDetailsComponent.vue';
    import EnrollCardsComponent from './modals/EnrollCardsComponent.vue';
    export default {
        components: {  OfferCalendarDetailsComponent, EnrollCardsComponent },
        name: "FeaturedMapDataViewComponent",
        props: ['offer', 'offerNumber'],
        data() {
            return {
                user: null,
                userEnrolledInAll: this.getUserEnrolledInAll(),
                activatedNow: false,
                activating: false,
                showEnrollModal:false,
                showDetailModal:false,
                show_offer_activation_failed_msg:false
            }
        },
        methods: {
            resetValues() {
                this.showEnrollModal = false;
                this.showDetailModal = false;
            },
            activate() {
                if(this.offer.OfferId) {
                    this.activating = true;
                    this.show_offer_activation_failed_msg = false;
                    axios.post(this.apiEndPoints.activateOffer, {
                        offer_id: this.offer.OfferId
                    }).then(response => {
                        if (response.data && response.data.ActivationId) {
                            if(response.data.Status && response.data.Status == 'ACTIVATED') {
                                this.activatedNow = true;
                                /**
                                 * emit a global event, so that if the same offer is rendered any where else on DOM, we mark it activated as well.
                                 */
                                this.$eventHub.$emit('offer_activated_' + this.offer.OfferId, this.offer.OfferId);
                            } else {
                                this.activatedNow = false;
                            }
                        } else {
                            this.show_offer_activation_failed_msg = true;
                        }
                    }).catch(error => {
                        this.show_offer_activation_failed_msg = true;
                        if (error.response && error.response.status && (error.response.status == 401 || error.response.status == 419)) {

                        }

                        return false;
                    }).finally ( () => {
                        this.activating = false;
                    });
                }

            },
            showOfferDetailModal() {
                this.resetValues();
                this.showDetailModal = true;
            },
            reload(user) {
                this.user = user;
                this.userEnrolledInAll = this.getUserEnrolledInAll();
                this.activatedNow = true;
            },

            getUserEnrolledInAll() {
                if(localStorage.getItem('user_obj')) {
                    this.user = JSON.parse(localStorage.getItem('user_obj'));
                }
                return (this.user && this.user.id && this.user.total_aggregators_enrolled_in == this.user.total_aggregators_count && this.user.total_aggregators_count > 0);
            },

            showEnrollCardOrActivate() {
                this.userEnrolledInAll = this.getUserEnrolledInAll();
                if(this.userEnrolledInAll) {
                    this.activate();
                } else {
                        this.resetValues();
                        this.showEnrollModal = true;
                    }
            },

        },
        updated() {
            if(this.showEnrollModal) {
                $.colorbox({
                    inline: true,
                    href: '#enroll-cards-modal-' + this.offer.OfferId,
                    width: '80%',
                    maxWidth: '800px',
                    opacity: '0.90',
                    closeButton: false,
                    onComplete: function () {
                        setTimeout(function () {
                            $.colorbox.resize();
                        }, 500);
                    }
                });
                $('.modal-close').on('click', function (e) {
                    e.preventDefault();
                    $.colorbox.close();
                });
            }

            if(this.showDetailModal) {
                $.colorbox({
                    inline: true,
                    href: this.offer.OfferProvider != 'rewards_network' ? '#offer-details-modal-' + this.offer.OfferId : '#offer-calendar-modal-' + this.offer.OfferId,
                    width: '80%',
                    maxWidth: '800px',
                    opacity: '0.90',
                    closeButton: false,
                    onComplete: function () {
                        setTimeout(function () {
                            $.colorbox.resize();
                        }, 500);
                    }
                });
            }
        },
        mounted() {

            if(localStorage.getItem('user_obj')) {
                this.user = JSON.parse(localStorage.getItem('user_obj'));
            }

            $('.modal-close').on('click', function (e) {
                e.preventDefault();
                $.colorbox.close();
            });

            this.$eventHub.$on('emit_from_map_'+this.offer.OfferId, (offerId) => {
                if(offerId == this.offer.OfferId) {
                    this.showOfferDetailModal();
                }
            });

            this.$eventHub.$on('offer_activated_'+this.offer.OfferId, (offerId) => {
                if(offerId == this.offer.OfferId) {
                    this.activatedNow = true;
                }
            });
        },
        created() {
        },
        beforeDestroy() {
            this.$eventHub.$off('emit_from_map_'+this.offer.OfferId);
            this.$eventHub.$off('offer_activated_'+this.offer.OfferId);
        },
    }
</script>

<style scoped>
    .isDisabled {
        pointer-events: none;
    }
    .offerActivationFailedMsg{
        color: #eb2d2e;
        font-size: 1vw;
        padding-top: 0.5vw;
    }
    </style>
